helpers.isDeferred = function(data) {
  if (data !== null && typeof data.then === 'function') {
    return true;
  } else {
    return false;
  }
};
